import * as path from 'path'

import type { AnvilToolOutput } from '@anvil/common/tools/list'
import type { AnvilFileSystem } from '@anvil/common/types/filesystem'

export async function listDirectory(params: {
  directoryPath: string
  projectPath: string
  fs: AnvilFileSystem
}): Promise<AnvilToolOutput<'list_directory'>> {
  const { directoryPath, projectPath, fs } = params

  try {
    const resolvedPath = path.resolve(projectPath, directoryPath)

    const entries = await fs.readdir(resolvedPath, {
      withFileTypes: true,
    })

    const files: string[] = []
    const directories: string[] = []

    for (const entry of entries) {
      if (entry.isDirectory()) {
        directories.push(entry.name)
      } else if (entry.isFile()) {
        files.push(entry.name)
      }
    }

    return [
      {
        type: 'json',
        value: {
          files,
          directories,
          path: directoryPath,
        },
      },
    ]
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error)
    return [
      {
        type: 'json',
        value: {
          errorMessage: `Failed to list directory: ${errorMessage}`,
        },
      },
    ]
  }
}
